/// <reference types="vite/client" />
import { sentenceCase } from "change-case"
import i18next from "i18next"
import { initReactI18next } from "react-i18next"

const translations: Record<string, Record<string, string>> = import.meta.glob(
  "./translations/en/**/*.translation.json",
  {
    eager: true,
  },
)

const resources = {
  en: {} as Record<string, string>,
}

const filenameToBasename = (filename: string, language: string) => {
  const withoutPath = filename.split("./translations/")[1] || ""
  const withoutLanguage = withoutPath.split(`${language}/`)[1] || ""
  return withoutLanguage.split(/\.\/?/)[0] || ""
}

Object.keys(translations).forEach(translationFileName => {
  const file = translations[translationFileName]
  resources["en"][filenameToBasename(translationFileName, "en")] = file.default
})

i18next
  .use({
    type: "postProcessor",
    name: "sentence-case",
    process: function (value: string) {
      return sentenceCase(value)
    },
  })
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackNS: "default",
    // keySeparator: true, // we do not use keys in form messages.welcome
    returnObjects: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18next
